import { render, staticRenderFns } from "./MovedRequestWtihPostiveClassReport.vue?vue&type=template&id=561e523c&"
import script from "./MovedRequestWtihPostiveClassReport.vue?vue&type=script&lang=js&"
export * from "./MovedRequestWtihPostiveClassReport.vue?vue&type=script&lang=js&"
import style0 from "./MovedRequestWtihPostiveClassReport.vue?vue&type=style&index=0&id=561e523c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports